import { Box, Text, Button } from '@betty/moonlight';
import { BottomSheet, useNavigation } from '@betty/navigation';
import { useDispatch } from '@betty/toolkit/state';
import { memo, useCallback } from 'react';
import { requestTimeout } from '../../state';
import { RgBottomSheetProps } from './BottomSheet.types';

function TimeoutBottomSheet({ close, value }: RgBottomSheetProps) {
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const handleSubmit = useCallback(async () => {
    await dispatch(requestTimeout(value));
    close();

    navigation.navigate('MainTabNavigator', { screen: 'Home' });

    BottomSheet.open({
      namespace: 'common',
      type: 'Info',
      titleNS: 'responsibleGaming',
      titleKey: 'limitsSavedTitle',
      data: {
        textNS: 'responsibleGaming',
        textKey: 'timeoutSuccessDescription',
      },
    });
  }, [dispatch, close, navigation, value]);

  return (
    <Box gap="space-600" marginTop="space-400">
      <Text
        variant="body-m-semi"
        locNS="responsibleGaming"
        locKey="timeoutDescriptionBottomSheet"
        color="darkSurfacePrimary"
      />
      <Box flexDirection="row" gap="space-200" alignSelf="flex-end">
        <Button
          variant="secondary"
          size="large"
          onPress={() => close()}
          locNS="common"
          locKey="cancel"
        />
        <Button
          variant="primary"
          size="large"
          onPress={handleSubmit}
          locNS="common"
          locKey="confirm"
        />
      </Box>
    </Box>
  );
}

export default memo(TimeoutBottomSheet);
